import React from 'react';

const Bubble = ({ pos }) => <div className={`bubble ${pos}`}></div>

export default Bubble;